import React from 'react';
import { useInvydioSessionPageLogic } from 'azshared';

export const InvydioEmbeddedSessionPage = () => {
  useInvydioSessionPageLogic();

  return <div/>;
};
